var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewOnButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 29,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Save Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7 0L3.3 0C1.4806 0 0 1.69711 0 3.78256L0 27.7388C6.30032e-05 27.9748 0.0579148 28.2061 0.166974 28.4062C0.276033 28.6064 0.43192 28.7675 0.616902 28.8712C0.801883 28.9748 1.00853 29.0169 1.21334 28.9926C1.41814 28.9682 1.61288 28.8785 1.7754 28.7336L11 20.5103L20.2246 28.7336C20.3869 28.879 20.5816 28.969 20.7865 28.9933C20.9914 29.0176 21.1981 28.9753 21.3829 28.871C21.5679 28.7674 21.7238 28.6064 21.8329 28.4062C21.942 28.2061 21.9999 27.9748 22 27.7388L22 3.78256C22 1.69711 20.5194 0 18.7 0ZM19.8 25.1616L11.6754 17.918C11.4825 17.7454 11.2449 17.6516 11.0002 17.6514C10.7555 17.6512 10.5177 17.7445 10.3246 17.9167L2.2 25.1616L2.2 3.78256C2.2 3.08783 2.6939 2.52171 3.3 2.52171L18.7 2.52171C19.3061 2.52171 19.8 3.08783 19.8 3.78256L19.8 25.1616Z",
    fill: "#AB2334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 25.1616L11.6754 17.918C11.4825 17.7454 11.2449 17.6516 11.0002 17.6514C10.7555 17.6512 10.5177 17.7445 10.3246 17.9167L2.2 25.1616L2.2 3.78256C2.2 3.08783 2.6939 2.52171 3.3 2.52171L18.7 2.52171C19.3061 2.52171 19.8 3.08783 19.8 3.78256L19.8 25.1616Z",
    fill: "#AB2334"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewOnButton);
export default __webpack_public_path__ + "static/media/ReviewOnButton.00d7a25acacc081d268480d57677044d.svg";
export { ForwardRef as ReactComponent };